import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
import { IkaBirimKatsayi } from 'libs/ika/src/lib/models/ika.models';
@Injectable()
export class GenBirimService {
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
    public birimTuru: string;
    public checkData: boolean;
    public isActive!: boolean;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public isYetki!: boolean;
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}

     setParams(birimTuru: string, checkData: boolean, isActive: boolean, isReadOnly:boolean, isBindCheck:boolean, isYetki: boolean){
      this.birimTuru = birimTuru;
      this.checkData = checkData;
      this.isActive = isActive;
      this.isReadOnly = isReadOnly;
      this.isBindCheck = isBindCheck;
      this.isYetki = isYetki;
     }

     getDlist(formName:string):any {
      const request=new GetDlist_Request({
        dListCode:formName
      })
       this._httpClient.post<GetDlist_Response>(`${env.lookupService}/System/GetDList`, request).pipe(
        tap(response => {
          this._gridControlsList.next(response.dListMetadata)
        }),
        catchError(err => throwError(err)),
        finalize(() => {})
      ).subscribe();
    }

  getData(code: number,control:any, birimTuru:string, baseEntity: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      if(this.isYetki) tableName = tableName + "?YetkiTuru=Y"
      dataSource = this.dataCoreService.getOData(tableName);
      dataSource.select([]);
    } 
    else{
      tableName = baseEntity;
      if(this.isYetki) tableName = tableName + "?YetkiTuru=Y"
      dataSource = this.dataCoreService.getOData(tableName);
      dataSource.select([]);

      const filterArr = [];
      if(birimTuru) filterArr.push(['BirimTuru', '=', birimTuru]);
      if(this.isActive && !isSetData) filterArr.push(['AktifEh', '=', 'E']);
      filterArr.push(['Kod', '=', code]);
      if (filterArr.length > 0) dataSource.filter(filterArr);
      }
    return dataSource;
  }

  getCheckData(code: number) {
    const dataSource = this.dataCoreService.getOData('IkaBirimKatsayi');
    dataSource.select(['Kod']);
    const filterArr = [];
    filterArr.push(['Kod', '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
}
}
